import { QrcodeCapture, QrcodeDropZone, QrcodeStream } from "vue-qrcode-reader";
import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("QrcodeStream", QrcodeStream);
  nuxtApp.vueApp.component("QrcodeDropZone", QrcodeDropZone);
  nuxtApp.vueApp.component("QrcodeCapture", QrcodeCapture);
});
